import { MOCK_MODE, mockConnectSSE } from './mockApi';

const API_URL = process.env.REACT_APP_TAKEOVER_API_URL || 'http://localhost:8000';

export function connectSSE(sessionId, onEvent) {
  // iter-24: in mock mode, the real takeover-api is not reachable.
  // Return a fake EventSource that fires scripted events on a timer.
  if (MOCK_MODE) {
    return mockConnectSSE(sessionId, onEvent);
  }

  // The session token authenticates the stream in the X-Session-Token header,
  // never the URL: a query string is recorded by load-balancer access logs,
  // browser history and Referer. EventSource cannot set a header, so this
  // reads the text/event-stream with fetch() and reconnects the way
  // EventSource would. Callers only use the returned object's close().
  const token = sessionStorage.getItem('sessionToken') || '';
  const url = `${API_URL}/api/takeover/sessions/${sessionId}/events`;
  let closed = false;
  let controller = null;

  const dispatch = (block) => {
    const data = block
      .split(/\r?\n/)
      .filter((line) => line.startsWith('data:'))
      .map((line) => line.slice(5).replace(/^ /, ''))
      .join('\n');
    if (!data) return; // comment (": ping") or empty block
    try {
      onEvent(JSON.parse(data));
    } catch (e) {
      console.error('SSE parse error:', e);
    }
  };

  const run = async () => {
    while (!closed) {
      controller = new AbortController();
      try {
        const res = await fetch(url, {
          headers: { 'X-Session-Token': token, Accept: 'text/event-stream' },
          cache: 'no-store',
          signal: controller.signal,
        });
        if (res.status === 401 || res.status === 404) {
          console.warn(`SSE refused (${res.status}); not retrying`);
          return;
        }
        if (!res.ok || !res.body) throw new Error(`SSE HTTP ${res.status}`);
        const reader = res.body.getReader();
        const decoder = new TextDecoder();
        let buf = '';
        for (;;) {
          const { value, done } = await reader.read();
          if (done) break;
          buf += decoder.decode(value, { stream: true });
          let m;
          while ((m = /\r?\n\r?\n/.exec(buf))) {
            dispatch(buf.slice(0, m.index));
            buf = buf.slice(m.index + m[0].length);
          }
        }
      } catch (e) {
        if (closed) return;
      }
      if (closed) return;
      console.warn('SSE connection error, will retry...');
      await new Promise((r) => setTimeout(r, SSE_RETRY_MS));
    }
  };

  run();
  return {
    close() {
      closed = true;
      if (controller) controller.abort();
    },
  };
}

// Matches EventSource's default reconnection delay.
export const SSE_RETRY_MS = 3000;
